// 인증 관련 API 함수들
import apiClient, { API_BASE_URL } from "@services/api/apiClient.jsx";
import axios from "axios";

const authApi = {
    // 사용자 정보 가져오기
    getCurrentUser: async () => {
        try {
            // JWT에서 사용자 ID 추출
            const accessToken = localStorage.getItem('ab_at');
            if (!accessToken) {
                throw new Error('인증 토큰이 없습니다.');
            }

            // JWT에서 사용자 ID 추출
            const tokenParts = accessToken.split('.');
            if (tokenParts.length === 3) {
                const base64 = tokenParts[1].replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(
                    atob(base64)
                    .split('')
                    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
                );
                const payload = JSON.parse(jsonPayload);
                const userId = payload.userId || payload.sub;

                // ID로 사용자 정보 요청
                const response = await apiClient.get(`/auth/${userId}`, {});
                return response.data;
            } else {
                throw new Error('유효하지 않은 토큰 형식입니다.');
            }
        } catch (error) {
            console.error('사용자 정보 가져오기 실패:', error);
            throw error;
        }
    },

    // 승인 대기 상태의 사용자 추가 정보 제출
    submitPendingApprovalInfo: async (additionalInfo, refreshToken = null) => {
        try {
            // JWT에서 사용자 ID 추출
            const accessToken = localStorage.getItem('ab_at');
            if (!accessToken) {
                throw new Error('인증 토큰이 없습니다.');
            }

            // JWT에서 사용자 ID 추출
            const tokenParts = accessToken.split('.');
            if (tokenParts.length === 3) {
                const base64 = tokenParts[1].replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(
                    atob(base64)
                    .split('')
                    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
                );
                const payload = JSON.parse(jsonPayload);
                const userId = payload.userId || payload.sub;

                // 헤더에 리프레시 토큰 추가
                const headers = {};
                if (refreshToken) {
                    headers['X-Refresh-Token'] = refreshToken;
                }

                // PUT 메소드로 사용자 정보 업데이트
                const response = await apiClient.put(`/auth/${userId}`, additionalInfo, { headers });
                return response.data;
            } else {
                throw new Error('유효하지 않은 토큰 형식입니다.');
            }
        } catch (error) {
            console.error('사용자 정보 업데이트 실패:', error);
            throw error;
        }
    },

    // at 갱신
    refreshToken: async () => {
        try {
            const accessToken = localStorage.getItem('ab_at');
            const refreshToken = localStorage.getItem('ab_rt');
            const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {
                accessToken,
                refreshToken
            });
            return response.data;
        } catch (error) {
            console.error('토큰 갱신 실패:', error);
            throw error;
        }
    },

    // 로그아웃
    logout: async () => {
        try {
            const response = await apiClient.post('/auth/logout');
            return response.data;
        } catch (error) {
            console.error('로그아웃 API 호출 실패:', error);
            throw error;
        }
    }
};

export default authApi;